//@ts-ignore
import * as securitypackage from '@securitypackage-api';
import { LeadCheckCode, errorCodeMap } from './model';

const leadsApi = {
	security: {
		package: securitypackage as typeof securitypackageApi,
		directory: {
			client: new securitypackage.DirectoryServiceClient() as DirectoryServiceClient,
		},
	},
	addLead: (lead: Lead, onComplete: (code: LeadCheckCode) => void) => {
		return new Promise<Lead>(resolve => {
			leadsApi.security.directory.client.addLead(lead, result => {
				onComplete(LeadCheckCode.VALID);

				resolve(result);
			});
			return; // MAR-115
			leadsApi.checkLeadEmail(lead.ContactEmail).then(code => {
				const validCodes = [LeadCheckCode.VALID, LeadCheckCode.HAS_TENANT_WITH_SAME_EMAIL];
				const isValid = validCodes.includes(code);

				if (isValid) {
					leadsApi.security.directory.client.addLead(lead, result => {
						onComplete(code);

						resolve(result);
					});
				} else {
					resolve(null);
					onComplete(code);
				}
			});
		});
	},
	checkLeadEmail: (email: string) => {
		return new Promise<LeadCheckCode>(resolve => {
			leadsApi.security.directory.client.checkLeadEmail(email, result => {
				resolve(errorCodeMap[result]);
			});
		});
	},
	fetchLeads: (dateRange: DateRange) => {
		return new Promise<Array<Lead>>(resolve => {
			leadsApi.security.directory.client.getLeads(dateRange.dateStart, dateRange.dateEnd, result => {
				resolve(result);
			});
		});
	},
	updateLead: (lead: Lead) => {
		return new Promise<Lead>(resolve => {
			leadsApi.security.directory.client.updateLead(lead, result => {
				resolve(result);
			});
		});
	},
};

export default leadsApi;
